/* ======================================================================
%%% File Name    : webSocket
%%% Authors      : Anders Hjelm, anders.hjelm@teliacompany.com
%%%
%%% Created      : 2016-12-15
%%% Copyright    : TeliaSonera Sverige AB 2016
%%%                Box 1218
%%%                SE-751 42 Uppsala, Sweden
%%%                The program may be used and/or copied only with the written
%%%                permission from TeliaSonera Sverige AB, or in accordance with the
%%%                terms and conditions stipulated in the agreement/contract
%%%                under which the program has been supplied.
%%%                All rights reserved.
%%%
%%% Purpose      : Module for handling web services.
%%%
========================================================================== */

import { createLogger } from '@telia-ace/edge-log';

const log = createLogger('utils/webSocket');

const ws = {};
const handlers = {};

export function messageHandler(instance, message) {
  handlers[instance](message);
}

export function wsNew(instance, wsUrl) {
  log.trace('New websocket:', wsUrl, instance);
  ws[instance] = new WebSocket(wsUrl);
}

export function wsBinaryType(instance, arg) {
  ws[instance].binaryType = arg;
}

export function wsOnOpen(instance, arg) {
  ws[instance].onopen = arg;
}

export function wsOnError(instance, arg) {
  ws[instance].onerror = arg;
}

export function wsOnClose(instance, arg) {
  ws[instance].onclose = arg;
}

export function wsOnMessage(instance, fun) {
  handlers[instance] = fun;
  ws[instance].onmessage = (msg) => {
    messageHandler(instance, msg);
  };
}

export function wsSend(instance, arg) {
  if (ws[instance] && ws[instance].readyState === WebSocket.OPEN) {
    ws[instance].send(arg);
  } else {
    log.debug('Attempt to use websocket when not defined or open. Instance: ', instance);
  }
}

// Will keep socket variable safely tucked into object
export function wsCheck(instance) {
  return ws[instance];
}

export function wsClose(instance) {
  if (ws[instance]) {
    ws[instance].close();
  } else {
    log.debug('Attempt to close websocket when not defined. Instance: ', instance);
  }
}

// Helper function to make sure that url:s are not created with multiple protocolsl
export function removeWebSocketProtocolFromUrl(url) {
  return url.replace('wss://', '').replace('ws://', '');
}
